<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Thông số kỹ thuật(*)
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            
            <parameter v-for="(item, index) in params" :key="index" :name="index" :data="item" :dpram.sync="form.param" :type="item.udt_type" />
            <seo
                :data.sync="form.meta_keyword"
                :error.sync="error.meta_keyword"/> 
            <detailSEO :data.sync="form.meta_description"/>
            <div style="height: 80px;" class="w-100 d-flex" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                    :disabled="loading" @click="submit()">Cập nhật</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        parameter : () => import('@/components/profile/create/param'),
        seo: () => import('@/components/profile/create/seo'),
        detailSEO: () => import('@/components/profile/create/detailSeo'),
        autocomplete: () => import('@/components/profile/create/autocomplete'),


    },
    data() {
        return {
            imgPrimary: false,
            id: this.$route.params.id,
            form: {
                param : [],
                meta_keyword : '',
                meta_description : '',
            },
            params : [],
            error: {},
            suggestCategory: [],
            loading: false,
        }
    },
    created() {
        this.$store.commit('dataTitle', 'Thông số kỹ thuật');
        // apiGet(`/v2/products/get_param?iCat=438`).then(res => {
        //     let data = res.data;
        //     this.params = data;
        // })
        setTimeout(function(){
            Vue.prototype.$message({
                message: 'Sản phẩm SEO tốt khi có đủ thông số kỹ thuật!',
                type: 'warning',
                center: true,
            });
        }, 1000)
       apiGet(`/v2/products/get_product_step_2`, {id :  this.$route.params.id}).then(res => {
            let data = res.data;
            this.params = data;
            this.form.meta_keyword = res.rowMeta.upm_keyword;
            this.form.meta_description = res.rowMeta.upm_description;

        }).catch(err => {
            if(err.status == 410){
                this.$message({
                    message: err.data.message,
                    type: 'warning',
                    center: true,
                });
                this.$router.push({
                        name: 'product-create',
                        query: ''
                    })
            }
        });

    },
    methods: {
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
            
            let form = {};
            form.iPro  = this.$route.params.id;
            form.param = this.form.param;
            form.meta_keyword = this.form.meta_keyword;
            form.meta_description = this.form.meta_description;
            
            await apiPost(`/v2/profile/products/create/push_data`, {form}).then(res => {
                if(res.data.success == 1){
                    this.$message({
                        message: 'Cập nhật thông tin thành công!',
                        type: 'success',
                        center: true,
                    });
                    //lên đưa sản phẩm vừa cập nhật về trang chi tiết
                    window.location.replace("https://vatgia.com/"+res.url);
                    // this.$router.push({
                    //     name: 'product',
                    //     params: {}
                    // })
                }else{
                    this.error = res.message.error;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            }).catch(err => {
                if(err.status == 422){
                    this.error = err.data;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            });
            this.loading = false;
        }
    }
};
</script>
<style lang='scss'>
    .btn_rdo{
        display: inline-block;
        background: #ccc;
        border-radius: 3px;
        color: #fff;
        height: 40px;
        line-height: 38px;
        opacity: 1;
        text-align: center;
        width: calc(50% - 4px);
        border: 1px solid #ccc;
        transition: all .3s;
        box-sizing: border-box;
        position: relative;
        font-weight: 700;
        margin-top: 0;
        font-size: 16px;
        &.btn_rdo_call{
            background: #33a837;
            border: 1px solid #33a837;
        }
        &.btn_rdo_buy{
            background: #f44f00;
            border: 1px solid #f44f00;
        }
    }
    .call-or-buy{
        padding: 11px 0;
        border-radius: 4px;
        border-top: 1px solid #007bff;
        // border-bottom: 1px solid #007bff;

        .buy-call{
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
            color: #007bff;
        }
    }
    .min-quantity,.unit, .quality, .type,.w-vat{
        width: calc(50% - 4px);

    }
    .min-quantity,.quality {
        margin-left: 8px;
    }
    input {
        box-shadow: none !important;
        -webkit-appearance: none !important;
    }
    .rv-create {
        .body {
            .select-mobile-post{
                border: 1px solid #007bff;
                border-radius: 4px;
            }
            .text-position-select{
                top: -13px;
                padding: 0 10px;
                background: #fff;
                margin-left: 10px;
            }
            .confirm {
                button {
                    padding: 8px 60px !important;
                }
            }
            .confirm-mobile {
                box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
                button {
                    width: 100%;
                }
            }
        }
    }
    .rv-create .body .select-mobile-post .ldc-placeholder-select-mobile i {
        float: right;
    }
    .rv-valiadate-input-form {
        input {
            border: 1px solid #dc3545 !important;
        }
        label {
            color: #dc3545 !important;
        }
    }
    .input-focus-effect {
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        input {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
            &:focus {
                border-color: #007bff;
            }
            &:focus + label {
                transform: translateY(0);
                top: -13px;
                color: #007bff;
                background: #fff;
                padding: 0 10px;
                font-size: 14px;
                margin-left: -5px;
            }
        }
        label {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
            color: #999;
            transition: 0.15s linear;
            font-size: 16px;
        }
        .input-on-alue {
            transform: translateY(0) !important;
            top: -13px !important;
            color: #007bff !important;
            background: #fff !important;
            padding: 0 10px !important;
            font-size: 14px !important;
            margin-left: -5px !important;
        }
    }
</style>
